import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IProgramAssistantActions, IThunkOnRestoreProgramAssistant } from '../types';

const onRestoreProgramAssistant: IThunkOnRestoreProgramAssistant = thunk(
  async ({ activateProgramAssistant }: Actions<IProgramAssistantActions>, payload) => {
    const { clinicId, programAssistantId } = payload;

    await api.programAssistant.restoreProgramAssistant(clinicId, String(programAssistantId));

    activateProgramAssistant(programAssistantId);
  },
);

export default onRestoreProgramAssistant;
